import { useEffect, useState } from 'react';
import {
  fetchSupportEmail,
  readSupportEmailBootstrapData,
} from '../services/contactEmail';

/**
 * Uses the build-time support email immediately and refreshes it after CSR.
 */
export const useSupportEmail = (): string => {
  const [supportEmail, setSupportEmail] = useState(readSupportEmailBootstrapData);

  useEffect(() => {
    let active = true;
    fetchSupportEmail()
      .then((currentEmail) => active && setSupportEmail(currentEmail))
      .catch((error) => console.warn('Failed to refresh contact email', error));
    return () => {
      active = false;
    };
  }, []);

  return supportEmail;
};
